import { DATA_SOURCES_MAPPING, ALL_DATA_SOURCES } from './dataSources';
import {
  DATA_SOURCE_METRIC_KEY_JOINER,
  METRICS_MAPPING,
  METRICS_NAMES_MAPPING,
  METRICS_NAMES_TOOLTIPS_MAPPING,
  METRICS_MODES_MAPPING,
  FLATTEN_METRICS_NAMES_MAPPING,
  FLATTEN_METRICS_NAMES_TOOLTIPS_MAPPING,
  FLATTEN_METRICS_MODES_MAPPING,
  METRICS_CALC_MODES_NAMES_MAPPING,
  MSCIENCE_ARPPU,
  ALL_ONLY_GLOBAL_DATA_METRICS,
  ALL_ONLY_MONTHLY_DATA_METRICS,
  ALL_DATASOURCES_METRICS,
} from './metrics';
import { PERIODS_MAPPING, PERIODS_NAMES_MAPPING } from './periods';
import {
  DEVICES_MAPPING,
  DEVICES_NAMES_MAPPING,
  ALL_PC_DEVICES,
  ALL_CONSOLE_DEVICES,
  ALL_DEVICES,
  ALL_DEVICES_BY_DATASOURCES,
} from './devices';
import {
  SEGMENTS_MAPPING,
  SEGMENTS_NAMES_MAPPING,
  ALL_SEGMENTS,
  SEGMENTS_NAMES_MAPPING_KEY,
  SEGMENTS_NAMES_MAPPING_TIP,
} from './segments';
import type { IDateType } from '@/pages/intelligence/types/common';

export {
  /** 数据源相关 **/
  DATA_SOURCES_MAPPING,
  ALL_DATA_SOURCES,
  /** 数据源相关 **/

  /** 指标相关 **/
  DATA_SOURCE_METRIC_KEY_JOINER,
  METRICS_MAPPING,
  METRICS_NAMES_MAPPING,
  METRICS_NAMES_TOOLTIPS_MAPPING,
  METRICS_MODES_MAPPING,
  FLATTEN_METRICS_NAMES_MAPPING,
  FLATTEN_METRICS_NAMES_TOOLTIPS_MAPPING,
  FLATTEN_METRICS_MODES_MAPPING,
  METRICS_CALC_MODES_NAMES_MAPPING,
  MSCIENCE_ARPPU,
  ALL_ONLY_GLOBAL_DATA_METRICS,
  ALL_ONLY_MONTHLY_DATA_METRICS,
  ALL_DATASOURCES_METRICS,
  /** 指标相关 **/

  /** 阶段相关 **/
  PERIODS_NAMES_MAPPING,
  /** 阶段相关 **/

  /** device相关 **/
  DEVICES_NAMES_MAPPING,
  ALL_PC_DEVICES,
  ALL_CONSOLE_DEVICES,
  ALL_DEVICES,
  ALL_DEVICES_BY_DATASOURCES,
  /** device相关 **/

  /** segments相关 **/
  SEGMENTS_NAMES_MAPPING,
  ALL_SEGMENTS,
  SEGMENTS_NAMES_MAPPING_KEY,
  SEGMENTS_NAMES_MAPPING_TIP,
  /** segments相关 **/
};

export const SIMPLE_DATE_FORMAT = 'YYYY-MM-DD';

// 国家筛选器组件，顶部的 Global、Global except China mainland 的选项配置
export const REGION_SELECTOR_RADIOS = [
  {
    value: 'global',
    text: 'Global',
    textCN: '全球',
  },
  // {
  //   value: 'global_wo_china',
  //   text: 'Global except China mainland',
  //   textCN: '全球（不包括中国大陆）',
  //   disabled: true,
  // },
];

/**
 * PCU、MAU、Digital Revenue、Physical Revenue 页签的 顶层配置
 * PERIODS -> 时间阶段配置
 * DATASOURCES -> 数据源配置
 * METRICS -> 指标配置
 * DEVICES -> devices设备配置
 * SEGMENTS -> segments配置，目前只有Digital Revenue有
 * VISUALIS_TOOLTIP_TITLE -> 可视化tooltip右侧的标题配置
 */
export const PERIODS_METRICS_CONFIG: {
  [key: string]: {
    PAGE_KEY: string;
    PAGE_NAME: string;
    ENTITY_TYPES: string[];
    DATE_TYPE: IDateType;
    DATE_TYPES: IDateType[];
    DATA_SOURCES_METRICS: {
      [key: string]: string[];
    };
    PERIODS: string[];
    DEVICES: string[];
    SEGMENTS: string[];
    VISUALIS_TOOLTIP_TITLE: string;
    PAGE_LOG_KEY: string;
  };
} = {
  PCU: {
    PAGE_KEY: 'pcu',
    PAGE_NAME: 'PCU',
    ENTITY_TYPES: ['pc'],
    DATE_TYPE: 'date',
    DATE_TYPES: ['date', 'week', 'month'],
    DATA_SOURCES_METRICS: {
      [DATA_SOURCES_MAPPING.STEAM_CHARTS]: [METRICS_MAPPING.PCU, METRICS_MAPPING.ACU],
    },
    PERIODS: [PERIODS_MAPPING.DAY_1, PERIODS_MAPPING.MONTH_1, PERIODS_MAPPING.MONTH_3, PERIODS_MAPPING.MONTH_6],
    DEVICES: [DEVICES_MAPPING.PC],
    SEGMENTS: [],
    VISUALIS_TOOLTIP_TITLE: '',
    PAGE_LOG_KEY: 'comparePCConsoleGamesPCU',
  },
  MAU: {
    PAGE_KEY: 'mau',
    PAGE_NAME: 'MAU',
    ENTITY_TYPES: ['pc', 'console'],
    DATE_TYPE: 'month',
    DATE_TYPES: ['month'],
    DATA_SOURCES_METRICS: {
      [DATA_SOURCES_MAPPING.NEWZOO]: [METRICS_MAPPING.MAU],
    },
    PERIODS: [PERIODS_MAPPING.MONTH_1, PERIODS_MAPPING.MONTH_3, PERIODS_MAPPING.MONTH_6, PERIODS_MAPPING.MONTH_12],
    DEVICES: [
      DEVICES_MAPPING.PC,
      DEVICES_MAPPING.PLAYSTATION4,
      DEVICES_MAPPING.PLAYSTATION5,
      DEVICES_MAPPING.XBOX_ONE,
      DEVICES_MAPPING.XBOX_SERIES_XS,
    ],
    SEGMENTS: [],
    VISUALIS_TOOLTIP_TITLE: 'MAU',
    PAGE_LOG_KEY: 'comparePCConsoleGamesMAU',
  },
  DIGITAL_REVENUE: {
    PAGE_KEY: 'digitalRevenue',
    PAGE_NAME: 'Digital Revenue',
    ENTITY_TYPES: ['pc', 'console'],
    DATE_TYPE: 'month',
    DATE_TYPES: ['date', 'week', 'month'],
    DATA_SOURCES_METRICS: {
      [DATA_SOURCES_MAPPING.MSCIENCE]: [
        METRICS_MAPPING.REVENUE,
        METRICS_MAPPING.UNITS,
        METRICS_MAPPING.AST,
        METRICS_MAPPING.ARPPU,
      ],
    },
    PERIODS: [PERIODS_MAPPING.WEEK_1, PERIODS_MAPPING.MONTH_1, PERIODS_MAPPING.MONTH_3, PERIODS_MAPPING.MONTH_6],
    DEVICES: [DEVICES_MAPPING.PC, DEVICES_MAPPING.PLAYSTATION, DEVICES_MAPPING.XBOX, DEVICES_MAPPING.NINTENDO],
    SEGMENTS: [
      SEGMENTS_MAPPING.FULL_GAME,
      SEGMENTS_MAPPING.DLC_ALL_OTHER,
      SEGMENTS_MAPPING.DLC_EXPANSION,
      SEGMENTS_MAPPING.DLC_CONTENT_PRE_PURCHASE_PASS,
      SEGMENTS_MAPPING.DLC_UNLOCKABLE_CONTENT_PASS,
      SEGMENTS_MAPPING.MTX,
      SEGMENTS_MAPPING.SUBSCRIPTION,
    ],
    VISUALIS_TOOLTIP_TITLE: '',
    PAGE_LOG_KEY: 'comparePCConsoleGamesDigitalRevenue',
  },
  PHYSICAL_REVENUE: {
    PAGE_KEY: 'physicalRevenue',
    PAGE_NAME: 'Physical Revenue',
    ENTITY_TYPES: ['pc', 'console'],
    DATE_TYPE: 'month',
    DATE_TYPES: ['month'],
    DATA_SOURCES_METRICS: {
      [DATA_SOURCES_MAPPING.NPD]: [METRICS_MAPPING.REVENUE],
    },
    PERIODS: [PERIODS_MAPPING.MONTH_1, PERIODS_MAPPING.MONTH_3, PERIODS_MAPPING.MONTH_6, PERIODS_MAPPING.MONTH_12],
    DEVICES: [
      DEVICES_MAPPING.PC,
      DEVICES_MAPPING.PLAYSTATION4,
      DEVICES_MAPPING.PLAYSTATION5,
      DEVICES_MAPPING.XBOX_ONE,
      DEVICES_MAPPING.XBOX_SERIES_XS,
      DEVICES_MAPPING.NINTENDO_WII_U,
      DEVICES_MAPPING.NINTENDO_SWITCH,
    ],
    SEGMENTS: [],
    VISUALIS_TOOLTIP_TITLE: 'Physical Revenue',
    PAGE_LOG_KEY: 'comparePCConsoleGamesPhysicalRevenue',
  },
};
